import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CadsWelcomeConfig } from './cads-welcome.config';

/**
 * Welcome / hero-style panel: title and optional subtitle, styled with CADS tokens.
 * All copy comes from {@link CadsWelcomeConfig}.
 */
@Component({
  selector: 'cads-welcome',
  standalone: true,
  templateUrl: './cads-welcome.component.html',
  styleUrl: './cads-welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsWelcomeComponent {
  readonly config = input.required<CadsWelcomeConfig>();
}
